module.exports = __webpack_public_path__ + "img/caret-up-fill-nor.db1b57be.svg";